module.exports = __webpack_public_path__ + "media/pages/press/downloads/LifeTime_Logo-ddbfd936c422df73aa1d80f3b0d8c218.png";